module.exports = __webpack_public_path__ + "static/img/s55.944a4bdc.png";